import AbsComponent from '../../common/components/AbsComponent';
import WinResize from '../../common/WinResize';

/**
 * MainBanner class
 * @category main
 */
class SeriesList extends AbsComponent{
  constructor(_store={}, _el='', _categoryList={}){
    super(_store, _el);
    this.selectListsCon = document.querySelector(`${this.el}`);
    this.selectLists = this.selectListsCon.querySelector(`.series-lists`);
    this.selectListsAll = this.selectLists.querySelectorAll('li');
    this.selectList = this.selectLists.querySelector(`.series-list[data-value='${this.store.id}']`);
    this.iscroll = null;
    this.resetTimer = null;
    this.clickTimer = null;
    this.isScroll = false;

    for(let ele of this.selectListsAll){
      let aliasName = ele.dataset.value;
      ele.querySelector('a').href = 'list?categoryId='+_categoryList[aliasName];
    }

    this.setting();
  }

  setting(){

    this.iscroll = new IScroll(this.el, {
      scrollX: true,
      freeScroll: true
    });
    this.iscroll.on('beforeScrollStart', ()=>{
      clearTimeout(this.resetTimer);
      clearTimeout(this.clickTimer);
    });
    this.iscroll.on('scrollEnd', ()=>{
      this.clickTimer = setTimeout(()=>{this.isScroll = false;}, 100);
      this.resetTimer = setTimeout(()=>{this.resize()}, 1500);
    });
    this.iscroll.on('scrollStart', ()=>{
      this.isScroll  = true;
    });

    for (let btn of this.selectLists.querySelectorAll('a')) {
      btn.addEventListener('click', (e)=>{
        if(this.isScroll)e.preventDefault();
      });
    }
    const winResize = WinResize.instance;
    winResize.init();
    winResize.addCallback(()=>{this.resize()});

    if(this.selectList)this.selectList.classList.add('is-active');

    this.resize()
  }
  resize(){
    if(!this.selectList)return;
    if(this.selectListsCon.clientWidth < this.selectLists.clientWidth){
      let gap = this.selectListsCon.clientWidth - this.selectLists.clientWidth;
      let tarX = (gap)/2 + (this.selectLists.clientWidth/2 - this.selectList.offsetLeft -this.selectList.clientWidth/2)
      if(tarX > 0)tarX = 0;
      if(tarX < gap)tarX = gap;
      this.iscroll.scrollTo(tarX, 0, 500, IScroll.utils.ease.quadratic);
    }
  }
}
export default SeriesList;
